import { defineComponent as n, openBlock as r, createBlock as a, unref as c, mergeProps as i, withCtx as p, createElementVNode as l } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconFireFilled",
  __name: "IconFireFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (m, e) => (r(), a(c(d), i(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        l("path", { d: "M12.27 13.98a13 13 0 0 1 .822.837c.521.595.808 1.126.808 1.624 0 1.195-.896 2.078-1.9 2.079-1.003 0-1.9-.884-1.9-2.079 0-.498.287-1.03.808-1.624a13 13 0 0 1 .822-.837L12 13.724l.27.256" }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M11.75 5A2.25 2.25 0 0 0 14 7.25a2.24 2.24 0 0 0 1.56-.633l.572-.552.518.604c1.658 1.934 3.004 4.298 3.419 6.62.421 2.36-.124 4.719-2.302 6.414-1.501 1.17-3.347 1.945-5.361 2.037L12 21.75c-2.173 0-4.166-.8-5.768-2.047-2.39-1.861-2.806-4.507-2.16-7.074.637-2.534 2.315-5.077 4.255-7.017L11.75 2.19V5m-.297 7.157c-.202.215-.454.45-.756.737a15 15 0 0 0-.917.935c-.583.665-1.18 1.55-1.18 2.612 0 1.93 1.478 3.579 3.4 3.579 1.923 0 3.4-1.65 3.4-3.579 0-1.063-.597-1.947-1.18-2.612a15 15 0 0 0-.916-.935c-.302-.288-.555-.522-.757-.737l-.546-.584-.548.584",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
